import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
// import Cookies from 'js-cookie'; // REMOVIDO: não usado
// import imgTeste from '../../img/imgTeste.png'; // REMOVIDO: não usado
import imgPizza from '../../img/Pizza2.png';
import './styleMobile.css';
import ModalItemAdicionado from "../../components/ModalItemAdicionado";
import { toast } from "react-toastify";
import ToastWithLink from './ToastWithLink';
import { getItemPublic, getStoreInfo, syncCarrinhoBackend } from "../../services/api";
import { FaPlus, FaMinus, FaCheck } from 'react-icons/fa';
import { MdFastfood } from "react-icons/md";
import SafeImage from '../../components/SafeImage';
import { useTranslation } from 'react-i18next';
import { formatPriceWithSymbol } from '../../utils/currency';
import Money from '../../components/Money';
import { getCartSessionToken } from '../../utils/cartSession';

const DetalheProduto = () => {
    const { t } = useTranslation('cardapio');
    const navigate = useNavigate();
    // Obtém o external_id da URL atual, se existir
    const [searchParams] = useSearchParams();
    const externalId = searchParams.get('external_id');
    const [empresa, setEmpresa] = useState(() => {
        try {
            const raw = sessionStorage.getItem('sessionCompany');
            return raw ? JSON.parse(raw) : null;
        } catch { return null; }
    });
    const location = useLocation();
    const [item, setItem] = useState(null);
    const [adicionais, setAdicionais] = useState([]);
    const { nomeEmpresaForUrl, idEmpresa, slug, objIdProduto } = useParams();
    const identifier = slug || idEmpresa;
    const isSlugRoute = !!slug;

    // Detectar modo salao da URL ou do state passado pelo Categoria
    const modeParam = searchParams.get('mode');
    const isSalao = modeParam === 'salao' || location.state?.mode === 'salao' || location.pathname.includes('/cardapio-salao');
    const mode = isSalao ? 'salao' : 'delivery';

    // 🔧 FIX: buildUrl com fallback para sessionStorage
    const buildUrl = (subpath) => {
        let base;
        if (isSlugRoute && slug) {
            base = `/c/${slug}/${subpath}`;
        } else if (nomeEmpresaForUrl && idEmpresa) {
            base = `/cardapio/${nomeEmpresaForUrl}/${idEmpresa}/${subpath}`;
        } else {
            // Fallback: buscar do sessionStorage
            try {
                const empresaData = sessionStorage.getItem('sessionCompany');
                if (empresaData) {
                    const parsed = JSON.parse(empresaData);
                    if (parsed?.slug) {
                        base = `/c/${parsed.slug}/${subpath}`;
                    } else if (parsed?.name && parsed?.id_empresa) {
                        const nomeForUrl = parsed.name.toLowerCase().replace(/\s+/g, '-');
                        base = `/cardapio/${nomeForUrl}/${parsed.id_empresa}/${subpath}`;
                    }
                }
            } catch (e) {
                console.error('[DETALHE] Erro ao construir URL:', e);
            }
            if (!base) {
                console.warn('[DETALHE] buildUrl: Não foi possível construir URL válida para:', subpath);
                base = `/cardapio/${nomeEmpresaForUrl}/${idEmpresa}/${subpath}`;
            }
        }
        const params = new URLSearchParams();
        if (externalId) params.set('external_id', externalId);
        if (isSalao) params.set('mode', 'salao');
        const qs = params.toString();
        return qs ? `${base}?${qs}` : base;
    };
    const [addedToCart, setAddedToCart] = useState(false);
    const EXPIRATION_TIME = 60 * 60 * 1000; // Tempo de expiração (1 hora em milissegundos)
    const [itensCarrinho, setItensCarrinho] = useState(() => {
        const itensFromStorage = localStorage.getItem('itensCarrinhoMobile');
        if (!itensFromStorage) return [];

        const now = Date.now();
        const itensFiltrados = JSON.parse(itensFromStorage).filter(item => now - item.addedAt < EXPIRATION_TIME);

        return itensFiltrados;
    });
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [selectedItemNome, setSelectedItemNome] = useState(null);
    const [quantidades, setQuantidades] = useState({});
    const [animationTrigger, setAnimationTrigger] = useState({});
    const [valueDescricao, setValueDescricao] = useState('');
    const descriptionRef = useRef();
    //const statusLoja = location.state?.statusLoja;
    const [statusLoja, setStatusLoja] = useState(location.state?.statusLoja ? location.state.statusLoja : null);

    useEffect(() => {
        const fetchItem = async () => {
            try {
                const response = await getItemPublic(identifier, objIdProduto);
                if (response.data.item) {
                    setItem(response.data.item);
                    // Adicionais já vêm do endpoint junto com o item
                    if (response.data.adicionais && response.data.adicionais.length > 0) {
                        setAdicionais(response.data.adicionais.map(adicional => ({
                            ...adicional,
                            quantidade: adicional.mandatory ? Math.max(1, adicional.min) : adicional.min || 0
                        })));
                    }
                }
            } catch (error) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao buscar item:', error);
            }
        };

        if (location.state?.item) {
            setItem(location.state?.item);
        } else {
            fetchItem();
        }
    }, [identifier, location.state?.item, objIdProduto]);

    const [openStatus, setOpenStatus] = useState("");
    // const [horariosFuncionamento, setHorariosFuncionamento] = useState(""); // REMOVIDO: não usado
    // const [currentTime, setCurrentTime] = useState(""); // REMOVIDO: não usado
    // const [loadingData, setLoadingData] = useState(true); // REMOVIDO: não usado
    // const [errorMessage, setErrorMessage] = useState(""); // REMOVIDO: não usado
    // const [showError, setShowError] = useState(false); // REMOVIDO: não usado

    useEffect(() => {
        (async () => {
            try {
                // Buscar empresa via API pública se não tivermos os dados
                if (!empresa && identifier) {
                    const empresaTemp = await getStoreInfo(identifier);
                    if (empresaTemp?.data?.empresaData) {
                        const empresaData = empresaTemp.data.empresaData;
                        setEmpresa(empresaData);
                        sessionStorage.setItem("sessionCompany", JSON.stringify(empresaData));

                        if (empresaData.status_loja === "sempre") {
                            setStatusLoja("aberto");
                            setOpenStatus("open");
                        }
                        if (!empresaData.status_loja) {
                            if (openStatus === "" || openStatus === "closed") {
                                toast(t('store.closed'), { toastId: 'store-closed', autoClose: false, type: 'error', position: 'bottom-center' });
                                setOpenStatus("closed");
                            }
                        }
                    }
                }
            } catch (error) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Unexpected error:", error);
            }
        })();
    }, [empresa, identifier, openStatus]);

    // Buscar adicionais quando o item veio via location.state (não veio do getItemPublic)
    useEffect(() => {
        const fetchAdicionais = async () => {
            try {
                const response = await getItemPublic(identifier, objIdProduto);
                if (response.data.adicionais && response.data.adicionais.length > 0) {
                    setAdicionais(response.data.adicionais.map(adicional => ({
                        ...adicional,
                        quantidade: adicional.mandatory ? Math.max(1, adicional.min) : adicional.min || 0
                    })));
                }
            } catch (error) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao buscar adicionais:', error);
            }
        };

        // Só buscar se item existe E veio do location.state (adicionais ainda vazios)
        if (item && location.state?.item && adicionais.length === 0 && item.has_adicional) {
            fetchAdicionais();
        }
    }, [identifier, objIdProduto, item, location.state?.item, adicionais.length]);

    /*const handleAddToCart = () => {
        if (!statusLoja || statusLoja === 'fechado') {
            toast.error(<ToastWithLink nomeEmpresaForUrl={nomeEmpresaForUrl} idEmpresa={idEmpresa} empresa={empresa} navigate={navigate} />);
            return;
        }

        if (item) {
            const gruposSelecionados = adicionais.map(adicionalPai => ({
                grupoId: adicionalPai._id,
                grupoTitle: adicionalPai.title,
                calcular_maior_valor: adicionalPai.calcular_maior_valor,
                adicionais: adicionalPai.adicionais.map(adicional => ({
                    adicionalId: adicional._id,
                    title: adicional.title,
                    quantity: quantidades[adicional._id] || 0,
                    price: isSalao ? (adicional.price_salao ?? adicional.price) : adicional.price
                })).filter(adicional => adicional.quantity > 0)
            })).filter(grupo => grupo.adicionais.length > 0);

            const newItem = {
                ...item,
                id: new Date().getTime(),
                quantity: 1,
                grupos_adicionais_selecionados: gruposSelecionados,
                observacoes_item: valueDescricao,
                price: item?.price || 0 //valorTotal().replace(',', '.')
            };
            const encryptedPrice = CryptoJS.AES.encrypt(newItem.price.toString(), secretKey).toString();
            const newItemWithoutImages = { ...newItem, price: encryptedPrice };
            delete newItemWithoutImages.image;
            setSelectedItemId(newItem.id);
            setSelectedItemNome(newItem.title);
            setItensCarrinho(prev => [...prev, newItemWithoutImages]);
            setAddedToCart(prevAddedToCart => !prevAddedToCart);
        }
    };*/

    const handleAddToCart = () => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🚀 Iniciando handleAddToCart");
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Status Loja>>>", statusLoja)
        if (!statusLoja || statusLoja === 'fechado') {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("❌ Loja fechada. Não é possível adicionar ao carrinho.");
            toast.error(<ToastWithLink empresa={empresa} navigate={navigate} />, { toastId: 'store-closed-action' });
            return;
        }

        if (item) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ Item válido para adicionar ao carrinho:", item);

            const valorBaseItem = isSalao ? (item?.price_salao ?? item?.price ?? 0) : (item?.price || 0);
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("💰 Valor base do item:", valorBaseItem);

            // valorTotal() retorna um número
            const valorTotalCalculado = valorTotal();
            const totalConvertido = typeof valorTotalCalculado === 'number' ? valorTotalCalculado : parseFloat(valorTotalCalculado) || 0;

            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("📊 Total calculado:", totalConvertido);

            const gruposSelecionados = adicionais.map(adicionalPai => ({
                grupoId: adicionalPai._id,
                grupoTitle: adicionalPai.title,
                calcular_maior_valor: adicionalPai.calcular_maior_valor,
                calcular_media: adicionalPai.calcular_media,
                adicionais: adicionalPai.adicionais.map(adicional => ({
                    adicionalId: adicional._id,
                    title: adicional.title,
                    quantity: quantidades[adicional._id] || 0,
                    price: isSalao ? (adicional.price_salao ?? adicional.price) : adicional.price
                })).filter(adicional => adicional.quantity > 0)
            })).filter(grupo => grupo.adicionais.length > 0);

            const newItem = {
                ...item,
                id: new Date().getTime(),
                quantity: 1,
                grupos_adicionais_selecionados: gruposSelecionados,
                observacoes_item: valueDescricao,
                price: valorBaseItem, // Define o valor base do item para o carrinho.
                total: totalConvertido, // Define o valor total calculado para exibição.
                addedAt: Date.now(), // 🔥 Adiciona um timestamp de quando o item foi inserido
            };

            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🆕 Novo item criado:", newItem);

            const newItemFinal = { ...newItem };

            // Recupera os itens do localStorage antes de atualizar
            const existingCart = localStorage.getItem('itensCarrinhoMobile')
                ? JSON.parse(localStorage.getItem('itensCarrinhoMobile'))
                : [];

            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🛒 Itens existentes no localStorage antes da atualização:", existingCart);

            // Atualiza a lista com o novo item
            const updatedCart = [...existingCart, newItemFinal];
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ Carrinho atualizado com novo item:", updatedCart);

            // Persistindo no estado primeiro
            setItensCarrinho(updatedCart);
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("📌 Estado do carrinho atualizado!");

            // Persistindo no localStorage
            localStorage.setItem('itensCarrinhoMobile', JSON.stringify(updatedCart));
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("💾 Itens no localStorage após adição:", JSON.parse(localStorage.getItem('itensCarrinhoMobile')));

            // 🛒 TRACKING DE ABANDONO: espelhar o carrinho no backend (fire-and-forget).
            // Captura o carrinho no instante em que o 1º item é adicionado → se o cliente
            // ficar 15 min sem ação, o job marca como abandonado (igual Uber Eats).
            // Usa o mesmo token do pedido (session_token_pedeja) → sem falso abandono ao comprar.
            try {
                let idEmpresaSync = idEmpresa;
                if (!idEmpresaSync) {
                    try { idEmpresaSync = JSON.parse(sessionStorage.getItem('sessionCompany'))?.id_empresa; } catch (e) { /* noop */ }
                }
                if (idEmpresaSync) {
                    const cartToken = getCartSessionToken();
                    syncCarrinhoBackend(idEmpresaSync, updatedCart, 'adicionou_item', cartToken).catch(() => { /* não bloquear UX */ });
                }
            } catch (e) { /* tracking nunca quebra o fluxo de adicionar ao carrinho */ }

            setSelectedItemId(newItem.id);
            setSelectedItemNome(newItem.title);
            setAddedToCart(prevAddedToCart => !prevAddedToCart);

            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🎉 Item adicionado ao carrinho com sucesso!");
        } else {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("⚠️ Nenhum item válido encontrado para adicionar ao carrinho.");
        }
    };



    const handleButtonClick = () => {
        if (!isRequirementMet()) {
            toast(t('product.selectRequiredExtras'), { autoClose: 5000, type: 'error' });
        } else {
            handleAddToCart();
        }
    };

    /*const valorTotal = () => {
        let valorTotalItem = item?.price || 0;
        adicionais.forEach(adicionalPai => {
            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("adicionalPai:",adicionalPai)
            adicionalPai.adicionais.forEach(adicional => {
                valorTotalItem += (quantidades[adicional._id] || 0) * adicional.price;
            });
        });
        return valorTotalItem.toFixed(2).toString().replace('.', ',');
    };*/
    /*const valorTotal = () => {
        let valorTotalItem = item?.price || 0;
    
        adicionais.forEach(adicionalPai => {
            if (adicionalPai.calcular_maior_valor) {
                // Se calcular_maior_valor for true, pegamos o maior valor entre os adicionais do grupo.
                const maxAdicionalValue = adicionalPai.adicionais.reduce((max, adicional) => {
                    const totalAdicional = (quantidades[adicional._id] || 0) * adicional.price;
                    return totalAdicional > max ? totalAdicional : max;
                }, 0);
    
                valorTotalItem += maxAdicionalValue;
            } else {
                // Caso contrário, somamos todos os valores dos adicionais multiplicados pela quantidade.
                adicionalPai.adicionais.forEach(adicional => {
                    valorTotalItem += (quantidades[adicional._id] || 0) * adicional.price;
                });
            }
        });
    
        return valorTotalItem.toFixed(2).toString().replace('.', ',');
    };*/
    const valorTotal = () => {
        // O valor base do item (o preço inicial sem considerar adicionais)
        // No modo salão, usa price_salao; fallback para price
        let valorBaseItem = isSalao ? (item?.price_salao ?? item?.price ?? 0) : (item?.price || 0);

        // Considera a quantidade do item no cálculo do valor base
        let valorTotalItem = valorBaseItem * (item?.quantity || 1);

        adicionais.forEach(adicionalPai => {
            if (adicionalPai.calcular_maior_valor) {
                // Se calcular_maior_valor for true, pegamos apenas o maior valor entre os adicionais do grupo que possuem quantidade > 0.
                const maxAdicionalValue = adicionalPai.adicionais
                    .filter(adicional => (quantidades[adicional._id] || 0) > 0) // Considera apenas os adicionais selecionados (quantidade > 0)
                    .reduce((max, adicional) => {
                        const totalAdicional = isSalao ? (adicional.price_salao ?? adicional.price) : adicional.price;
                        return totalAdicional > max ? totalAdicional : max;
                    }, 0);

                valorTotalItem += maxAdicionalValue;
            } else if (adicionalPai.calcular_media) {
                // Se calcular_media for true, calculamos a média dos valores dos adicionais selecionados.
                const adicionaisSelecionados = adicionalPai.adicionais
                    .filter(adicional => (quantidades[adicional._id] || 0) > 0); // Filtra apenas os adicionais com quantidade > 0

                if (adicionaisSelecionados.length > 0) {
                    // Calcula a média dos valores dos adicionais selecionados
                    const somaValores = adicionaisSelecionados.reduce((acc, adicional) => {
                        const quantidadeSelecionada = quantidades[adicional._id] || 0;
                        const precoAdicional = isSalao ? (adicional.price_salao ?? adicional.price) : adicional.price;
                        return acc + (precoAdicional * quantidadeSelecionada);
                    }, 0);
                    const mediaValor = somaValores / adicionaisSelecionados.length;
                    valorTotalItem += mediaValor;
                }

            } else {
                // Caso contrário, somamos todos os valores dos adicionais multiplicados pela quantidade.
                const totalAdicionais = adicionalPai.adicionais.reduce((acc, adicional) => {
                    const quantidadeSelecionada = quantidades[adicional._id] || 0;
                    const precoAdicional = isSalao ? (adicional.price_salao ?? adicional.price) : adicional.price;
                    return acc + (precoAdicional * quantidadeSelecionada);
                }, 0);

                valorTotalItem += totalAdicionais;
            }
        });

        // Retorna o valor total como número (formatação na exibição)
        return valorTotalItem;
    };

    /*const isRequirementMet = () => {
        return adicionais.every(adicionalPai => {
            if (!adicionalPai.mandatory) return true;

            const totalItems = adicionalPai.adicionais.reduce((acc, adicional) => {
                return acc + (quantidades[adicional._id] || 0);
            }, 0);

            return adicionalPai.min > 0 ? totalItems >= adicionalPai.min : true;
        });
    };*/
    const isRequirementMet = useCallback(() => {
        return adicionais.every(adicionalPai => {
            if (!adicionalPai.mandatory) return true;
    
            // 🔥 Filtra apenas os adicionais que estão visíveis (não estão `out` / `out_salao`)
            const adicionaisVisiveis = adicionalPai.adicionais.filter(adicional => {
                if (adicional.out) return false;
                if (isSalao && adicional.out_salao) return false;
                return true;
            });
    
            // Se nenhum adicional visível está disponível, ignora a obrigatoriedade
            if (adicionaisVisiveis.length === 0) return true;
    
            // Conta quantos adicionais foram selecionados
            const totalItems = adicionaisVisiveis.reduce((acc, adicional) => {
                return acc + (quantidades[adicional._id] || 0);
            }, 0);
    
            return adicionalPai.min > 0 ? totalItems >= adicionalPai.min : true;
        });
    }, [adicionais, quantidades]);
    

    /*useEffect(() => {
        const itensWithoutImages = itensCarrinho.map(item => {
            const { price, ...itemWithoutImages } = item;
            const decryptedPrice = CryptoJS.AES.decrypt(price, secretKey).toString(CryptoJS.enc.Utf8);
            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("decryptedPrice:",decryptedPrice)
            const totalValue = item?.quantity * parseFloat(decryptedPrice);
            const encryptedTotalValue = CryptoJS.AES.encrypt(totalValue.toString(), secretKey).toString();
            return { ...itemWithoutImages, price, totalValue: encryptedTotalValue };
        });
        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("itensWithoutImages:",itensWithoutImages)
        localxStorage.setItem('itensCarrinho', JSON.stringify(itensWithoutImages));
    }, [itensCarrinho]);*/
    //const EXPIRATION_TIME = 60 * 60 * 1000; // 1 hora



    useEffect(() => {
        const itensProcessados = itensCarrinho.map(item => {
            const price = typeof item.price === 'number' ? item.price : parseFloat(item.price) || 0;
            const totalValue = (item?.quantity || 1) * price;
            return { ...item, totalValue };
        });

        localStorage.setItem('itensCarrinhoMobile', JSON.stringify(itensProcessados));
    }, [itensCarrinho]);

    useEffect(() => {
        isRequirementMet();
    }, [quantidades, isRequirementMet]);

    const handleIncrement = (idPai, id) => {
        setQuantidades(prev => {
            const grupo = adicionais.find(adicional => adicional._id === idPai);
            const maxTotal = grupo.max;
            const calculaMediaOuMaiorValor = grupo.calcular_maior_valor || grupo.calcular_media;

            // Calcula o total de adicionais já selecionados no grupo (excluindo o atual)
            const totalAtual = grupo.adicionais.reduce((acc, adicional) => acc + (prev[adicional._id] || 0), 0);

            // Verifica se podemos adicionar mais adicionais sem ultrapassar o máximo
            if (totalAtual >= maxTotal) {
                return prev; // Não permite adicionar mais adicionais
            }

            // Verifica a quantidade do adicional específico que estamos tentando incrementar
            const totalAtualDoAdicional = prev[id] || 0;

            // Se o adicional tiver 'calcular_maior_valor' ou 'calcular_media', limita a 1
            if (calculaMediaOuMaiorValor && totalAtualDoAdicional >= 1) {
                return prev; // Se já houver 1, não permite adicionar mais
            }

            // Para adicionais normais, apenas limita o total no grupo
            if (!calculaMediaOuMaiorValor && totalAtual + 1 > maxTotal) {
                return prev; // Se o total no grupo exceder o maxTotal, não permite adicionar mais
            }

            // Se não houver violação de limites, incrementa o adicional
            setLastValues(last => ({ ...last, [id]: prev[id] || 0 }));
            setAnimationTrigger(trigger => ({ ...trigger, [id]: (trigger[id] || 0) + 1 }));
            return { ...prev, [id]: (prev[id] || 0) + 1 };
        });
    };

    const totalCurrent = (idPai) => {
        return adicionais.find(adicional => adicional._id === idPai).adicionais.reduce((acc, adicional) => {
            return acc + (quantidades[adicional._id] || 0);
        }, 0);
    };

    const isSelected = (adicionalPai) => {
        const totalItems = adicionalPai.adicionais.reduce((acc, adicional) => {
            return acc + (quantidades[adicional._id] || 0);
        }, 0);

        return totalItems >= (adicionalPai.min || 1);
    };

    const handleDecrement = (id) => {
        setQuantidades(prev => {
            if (prev[id] > 0) {
                setLastValues(last => ({ ...last, [id]: prev[id] }));
                setAnimationTrigger(trigger => ({ ...trigger, [id]: (trigger[id] || 0) + 1 }));
                return { ...prev, [id]: prev[id] - 1 };
            }
            return prev;
        });
    };

    const [lastValues, setLastValues] = useState({});

    // const updateQuantity = (id, newQuantity) => { // REMOVIDO: não usado
    //     setQuantidades(prev => {
    //         const lastQuantity = prev[id] || 0;
    //         setLastValues(last => ({ ...last, [id]: lastQuantity }));
    //         return { ...prev, [id]: newQuantity };
    //     });
    // };

    const getAnimationClass = (id) => {
        if (lastValues[id] === undefined) return '';
        return quantidades[id] > lastValues[id] ? 'slideDown' : 'slideUp';
    };

    // 🔧 FIX: handleBack com fallback para sessionStorage
    const handleBack = () => {
        let baseUrl;
        if (isSlugRoute && slug) {
            baseUrl = `/c/${slug}`;
        } else if (nomeEmpresaForUrl && idEmpresa) {
            baseUrl = `/cardapio/${nomeEmpresaForUrl}/${idEmpresa}`;
        } else if (empresa?.slug) {
            baseUrl = `/c/${empresa.slug}`;
        } else if (empresa?.name && empresa?.id_empresa) {
            const nomeForUrl = empresa.name.toLowerCase().replace(/\s+/g, '-');
            baseUrl = `/cardapio/${nomeForUrl}/${empresa.id_empresa}`;
        } else {
            console.warn('[DETALHE] Usando history.back() como fallback');
            navigate(-1);
            return;
        }

        const params = new URLSearchParams();
        if (externalId) params.set('external_id', externalId);
        if (isSalao) params.set('mode', 'salao');
        const qs = params.toString();
        navigate(qs ? `${baseUrl}?${qs}` : baseUrl);
    };

    const handleMaxCharDescricao = (e) => {
        const newValue = e.target.value;
        if (newValue.length <= 200) {
            setValueDescricao(newValue);
        }
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, []);

    return (
        <div className="detalhe-page">
            <ModalItemAdicionado
                addedToCart={addedToCart}
                setAddedToCart={setAddedToCart}
                setItensCarrinho={setItensCarrinho}
                itensCarrinho={itensCarrinho}
                selectedItemId={selectedItemId}
                selectedItemNome={selectedItemNome}
            />
            {/* Header desktop */}
            <div className="detalhe-header-desktop">
                <div className="detalhe-header-back" onClick={handleBack}>
                    <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
                </div>
                <span className="detalhe-header-title">{t('product.details', 'Detalhes do produto')}</span>
                <div className="detalhe-header-actions">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3E3E3E" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><circle cx={18} cy={5} r={3} /><circle cx={6} cy={12} r={3} /><circle cx={18} cy={19} r={3} /><line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" /></svg>
                </div>
            </div>
            {/* Mobile back/share buttons (hidden on desktop) */}
            <div className="backButtonDetalhe detalhe-mobile-only" onClick={handleBack}>
                <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-left"><polyline points="15 18 9 12 15 6" /></svg>
            </div>
            <div className="compartilharButtonDetalhe detalhe-mobile-only">
                <svg xmlns="http://www.w3.org/2000/svg" width="22.75" height="22.75" viewBox="0 0 24 24" fill="none" stroke="#3E3E3E" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-share-2"><circle cx={18} cy={5} r={3} /><circle cx={6} cy={12} r={3} /><circle cx={18} cy={19} r={3} /><line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" /></svg>
            </div>
            <div className="detalhe-content">
                {/* Image + Info section */}
                <div className="detalhe-hero">
                    <div className="detalhe-image">
                        <SafeImage
                            src={item?.image}
                            alt="product"
                            fallback={
                                item?.type === "pizza"
                                    ? <img src={imgPizza} alt="product" />
                                    : <div className="detalhe-image-fallback"><MdFastfood /></div>
                            }
                        />
                    </div>
                    <div className="detalhe-info">
                        <h3 className="detalhe-title">{item?.title}</h3>
                        <p className="detalhe-price"><Money value={isSalao ? (item?.price_salao ?? item?.price) : item?.price} inline /></p>
                        <p className="detalhe-description" dangerouslySetInnerHTML={{ __html: item?.description?.replace(/\n/g, '<br/>') }}></p>
                    </div>
                </div>
            {adicionais && adicionais.length > 0 &&
                adicionais
                    // 🔥 Filtra os pais que tenham pelo menos um filho disponível
                    .filter(adicionalPai => adicionalPai.adicionais.some(adicional => !adicional.out && !(isSalao && adicional.out_salao)))
                    // 🔥 Ordena colocando os do tipo "pizza" no início
                    .sort((a, b) => {
                        // Ordena colocando os do tipo "pizza" no início
                        if (a.type === 'pizza' && b.type !== 'pizza') return -1;
                        if (a.type !== 'pizza' && b.type === 'pizza') return 1;
                        return 0; // Mantém a ordem original para os que têm o mesmo tipo
                    }).map((adicionalPai, i) => {
                        // 🔥 Verifica se há pelo menos um adicional disponível
                        const temAdicionalDisponivel = adicionalPai.adicionais.some(adicional => !adicional.out && !(isSalao && adicional.out_salao));

                        // 🔥 Se não há adicionais disponíveis, removemos a obrigatoriedade
                        const isMandatory = temAdicionalDisponivel ? adicionalPai.mandatory : false;

                        return (
                            <div key={i}>
                                {temAdicionalDisponivel && (
                                    <div className="observacoesDetalhe">
                                        <div className="obsTextBox" style={{ width: "100%" }}>
                                            <div className="adicionalTitleText">
                                                <div className="childrenDivTitleAdicionalCardapio">
                                                    <span>{adicionalPai.title}</span>
                                                    {isMandatory && (
                                                        <>
                                                            <label className={isSelected(adicionalPai) ? "hidden" : "visible"}>{t('product.required')}</label>
                                                            <FaCheck className={isSelected(adicionalPai) ? "visible" : "hidden"} style={{ color: "green", fontSize: "1.2em" }} />
                                                        </>
                                                    )}
                                                </div>
                                                <p>
                                                    {isMandatory && adicionalPai.min > 1
                                                        ? t('product.chooseMinAndMax', { min: adicionalPai.min, max: adicionalPai.max, optionLabel: adicionalPai.max === 1 ? t('product.oneOption') : t('product.multipleOptions', { count: adicionalPai.max }) })
                                                        : t('product.chooseMax', { max: adicionalPai.max, optionLabel: adicionalPai.max === 1 ? t('product.oneOption') : t('product.multipleOptions', { count: adicionalPai.max }) })
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {temAdicionalDisponivel &&
                                    adicionalPai.adicionais
                                        .filter(adicional => !adicional.out && !(isSalao && adicional.out_salao)) // 🔥 Filtra apenas os adicionais disponíveis
                                        .map((adicional, index) => (
                                            <div key={adicional._id} className="containerPaiAdicionais">
                                                <div className={`divContendoAdicionais ${index === 0 ? "first" : ""}`}>
                                                    <div style={{ width: "70%", display: "flex", flexDirection: "row", gap: 7 }}>
                                                        {adicional.image === "" || !adicional.image ? (
                                                            adicionalPai?.type === "pizza" ? (
                                                                <img className="h-56 w-full object-cover" width={50} height={50} src={imgPizza} alt="product" />
                                                            ) : (
                                                                <div>
                                                                    <MdFastfood style={{ fontSize: 50 }} />
                                                                </div>
                                                            )
                                                        ) : (
                                                            <SafeImage
                                                                src={adicional.image}
                                                                alt="img"
                                                                className="imgAdicional"
                                                                fallback={<div><MdFastfood style={{ fontSize: 50 }} /></div>}
                                                            />
                                                        )}
                                                        <div>
                                                            <label htmlFor={`adicional_${adicional._id}`} className="text-adicional-item">
                                                                {adicional.title}
                                                            </label>
                                                            <div style={{ color: "#1095F3", fontWeight: 500 }}>
                                                                {formatPriceWithSymbol(isSalao ? (adicional.price_salao ?? adicional.price) : adicional.price)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* No modo salão, não permite selecionar adicionais */}
                                                    {!isSalao && (
                                                        <div style={{ width: "25%" }} className="adicional-controls">
                                                            <div onClick={() => handleDecrement(adicional._id)} style={{ visibility: quantidades[adicional._id] ? "visible" : "hidden" }}>
                                                                <FaMinus style={{ color: "orangered", fontSize: "16px", cursor: "pointer" }} />
                                                            </div>
                                                            <div style={{ visibility: quantidades[adicional._id] ? "visible" : "hidden" }}>
                                                                <span className={`animated-number ${getAnimationClass(adicional._id)}`} key={`${adicional._id}-${animationTrigger[adicional._id] || 0}`}>
                                                                    {quantidades[adicional._id] || 0}
                                                                </span>
                                                            </div>
                                                            <div
                                                                onClick={() => handleIncrement(adicionalPai._id, adicional._id)}
                                                                style={{
                                                                    color: totalCurrent(adicionalPai._id) >= adicionalPai.max ? "#ccc" : "#1095F3",
                                                                    fontSize: "20px",
                                                                    marginBottom: 3,
                                                                    cursor: totalCurrent(adicionalPai._id) >= adicionalPai.max ? "not-allowed" : "pointer",
                                                                }}
                                                                disabled={totalCurrent(adicionalPai._id) >= adicionalPai.max}
                                                            >
                                                                <FaPlus />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))
                                }
                            </div>
                        );
                    })}

            {/* No modo salão, o cardápio é apenas para visualização - sem observações nem carrinho */}
            {!isSalao && (
                <>
                    <div className="observacoesDetalhe">
                        <div className="obsTextBox">
                            <div className="obsText">
                                <span>{t('product.observations')}</span>
                            </div>
                        </div>
                    </div>
                    <div className="obsTextBoxContainer">
                        <div className="obsTextBoxData">
                            <textarea placeholder={t('product.observationPlaceholder')}
                                value={valueDescricao} onChange={handleMaxCharDescricao}
                                maxLength="200" className="text-areaObs"
                                ref={descriptionRef}
                            />
                            <div className="divCounterChar">{valueDescricao.length}/200</div>
                        </div>
                    </div>
                </>
            )}
            {!isSalao && (
                <div className="avancarDetalhe">
                    <button onClick={handleButtonClick}
                        className={`btnAvancarDetalhe ${!isRequirementMet() ? 'btnDisabledStyle' : ''}`}
                    >
                        <p style={{ marginBottom: "0px" }}>{t('product.advance')}</p>
                        <div className="btndata"><Money value={valorTotal()} inline /></div>
                    </button>
                </div>
            )}
            </div>{/* end detalhe-content */}
        </div>
    );
};

export default DetalheProduto;
